import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ServiceV2 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return	<section className="service-three  go-top">
		  <div className="container">
		    <div className="block-title-two text-center">
		      <h3>Help more. Convert faster. Sell smarter, with AI.</h3>
		    </div>{/* /.block-title-two text-center */}
		    <div className="row">
		      <div className="col-xl-3 col-lg-6">
		        <div className="service-three__single">
		          <i className="fal fa-star" />
		          <h3><Link to="/effortless-setup-integration">Effortless Setup & Integration</Link></h3>
		          <p>Seamlessly connects with your website or CRM for a smooth, hassle-free experience.</p>
		        </div>{/* /.service-three__single */}
		      </div>{/* /.col-lg-3 col-md-6 */}
		      <div className="col-xl-3 col-lg-6">
		        <div className="service-three__single">
		          <i className="fal fa-umbrella" />
		          <h3><Link to="/accurate-intelligent-responses">Accurate & Intelligent Responses</Link></h3>
		          <p>Advanced AI understands intent and delivers precise answers instantly.</p>
		        </div>{/* /.service-three__single */}
		      </div>{/* /.col-lg-3 col-md-6 */}
		      <div className="col-xl-3 col-lg-6">
		        <div className="service-three__single">
		          <i className="fal fa-laptop-code" />
		          <h3><Link to="/smart-lead-capture-conversion">Smart Lead Capture & Conversion</Link></h3>
		          <p> Automatically identifies and routes high-intent leads to boost conversions.</p>
		        </div>{/* /.service-three__single */}
		      </div>{/* /.col-lg-3 col-md-6 */}
		      <div className="col-xl-3 col-lg-6">
		        <div className="service-three__single">
		          <i className="fal fa-database" />
		          <h3><Link to="/scalable-business-performance">Scalable Business Performance</Link></h3>
		          <p>Handles high volumes and multi-channel growth with consistent performance.</p>
		        </div>{/* /.service-three__single */}
		      </div>{/* /.col-lg-3 col-md-6 */}
		    </div>{/* /.row */}
		  </div>{/* /.container */}
		</section>


        }
}

export default ServiceV2